import { orgWordFor } from '@app/shared'
import { PRODUCTS } from '@app/shared/brand'
import { useQuery } from '@tanstack/react-query'
import { ArrowRight, HandCoins } from 'lucide-react'
import { townLine } from '../../lib/address-place'
import { orgHref } from '../../lib/public-router'
import { useTRPC } from '../../lib/trpc'
import { Notice } from '../../ui'
import { SiteShell } from '../../ui/SiteShell'
import { TERUMAH_NAV } from './product-nav'
import './marketing.css'

const orgWord = orgWordFor('terumah')
const orgsWord = 'organizations'
const titledOrgsWord = 'Organizations'

/** The charities that chose to appear on the giving product's public list. */
export function OrgsPage({ onLogin }: { onLogin?: () => void }) {
  const trpc = useTRPC()
  const orgs = useQuery(trpc.org.directory.queryOptions({ kind: 'chesed' }))
  const listed = orgs.data ?? []

  return (
    <SiteShell nav={TERUMAH_NAV} onLogin={onLogin}>
      <section className="mk-section mk-section--first">
        <div className="mk-measure">
          <header className="mk-section__head">
            <p className="mk-eyebrow">{PRODUCTS.terumah.name}</p>
            <h1 className="mk-section__title">
              {titledOrgsWord} accepting gifts here
            </h1>
            <p className="mk-section__lede">
              Each {orgWord} chose to appear in this directory. Open one to
              reach its own giving page.
            </p>
          </header>

          {orgs.isLoading ? <Notice>Loading…</Notice> : null}
          {orgs.isError ? (
            <Notice tone="error">The directory could not be loaded.</Notice>
          ) : null}
          {!orgs.isLoading && !orgs.isError && listed.length === 0 ? (
            <Notice>No {orgsWord} are listed yet.</Notice>
          ) : null}

          <div className="mk-dir">
            {listed.map((org) => (
              <a
                className="mk-dir__row"
                key={org.shortId}
                href={orgHref(org.shortId, '')}
              >
                <span className="mk-dir__names">
                  <span className="mk-dir__name">{org.name}</span>
                  {org.nameHe ? (
                    <span className="mk-dir__name-he" dir="rtl">
                      {org.nameHe}
                    </span>
                  ) : null}
                </span>

                <span className="mk-dir__where">
                  {townLine({
                    city: org.city,
                    region: org.region,
                    country: org.country,
                  })}
                </span>

                <span className="mk-dir__pages">
                  <span className="mk-dir__page">
                    <HandCoins className="mk-dir__icon" aria-hidden />
                    Give
                  </span>
                </span>

                <ArrowRight className="mk-dir__go" aria-hidden />
              </a>
            ))}
          </div>
        </div>
      </section>
    </SiteShell>
  )
}
